import { useTracking } from 'react-tracking';
import { useMount } from '@simplywallst/ui-core';
import { Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';

import { Alert, AlertAction } from '@simplywallst/ui-core';

import { Profile } from './components/Profile';

type Props = {
  displayName: string;
};

export const NarrativeCommunityProfile = ({ displayName }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
  });
  useMount(() => {
    trackEvent({ subject: 'page', action: 'landed' });
  });

  return (
    <Track>
      <ErrorBoundary
        fallback={
          <div className="relative grid w-full max-w-screen-xl md:p-x2 lg:p-x3">
            <Alert
              styleType="negative"
              actions={
                <AlertAction onClick={() => window.location.reload()}>
                  Reload
                </AlertAction>
              }
            >
              Failed to load community profile. Please try again.
            </Alert>
          </div>
        }
      >
        <Suspense
          fallback={
            <div
              className="relative grid w-full max-w-screen-xl md:p-x2 lg:p-x3"
              role="presentation"
              aria-label="Loading skeleton"
            >
              <p className="text-solid">Loading...</p>
            </div>
          }
        >
          <Profile displayName={displayName} />
        </Suspense>
      </ErrorBoundary>
    </Track>
  );
};
